import React from 'react';
import classNames from 'classnames';
import { HyperdbListing } from '../../../../hyperdb';

export default HyperdbListing({
  collectionName: 'property_groups',
  namespace: 'propertyGroup',
  mountedUrl: '/propertyGroups',
  title: 'Groups',
  columns: [
    { attribute: 'name' },
    { attribute: 'description' },
  ],
  useQuickSearch: true,
});



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/propertyGroup/containers/Listing.jsx